import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DateHelperService } from 'src/app/core/helpers/date-helper/date-helper.service';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { Appointment } from 'src/app/core/models/appointment.model';
import { TicketStatusTransition } from 'src/app/core/models/ticket-status-transition.model';
import { TicketStatusTransitionsService } from 'src/app/core/services/ticket-status-transitions/ticket-status-transitions.service';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';
import { SyncService } from 'src/app/core/sync/sync.service';

@Component({
     selector: 'app-appointment-list',
     templateUrl: './appointment-list.component.html',
     styleUrls: ['./appointment-list.component.scss'],
})
export class AppointmentListComponent implements OnInit, OnDestroy {

     pageTitle = 'Appointments';

     appointments = [] as Appointment[];
     transitions = [] as TicketStatusTransition[];
     isLoading = false;
     private syncSubscription: Subscription;
     private ticketStatusUpdateSubscription: Subscription;

     constructor(
          private storageService: LocalStorageService,
          private ticketStatusTransitionService: TicketStatusTransitionsService,
          private syncService: SyncService,
          private logger: LoggerService,
          private dateHelperService: DateHelperService
     ) { }

     ngOnInit() {
          this.syncService.pushDateString(this.myDate);
          this.loadData();
          this.updateAfterSync();
          this.subscribeToTicketUpdates();
     }

     ngOnDestroy(): void {
          this.syncSubscription.unsubscribe();
          this.ticketStatusUpdateSubscription.unsubscribe();
     }

     hasAppointments() {
          return this.appointments && this.appointments.length;
     }

     getTodaysDate() {
          return new Date();
     }

     private updateAfterSync() {
          this.syncSubscription = this.syncService.isSyncing$
               .subscribe(isSyncing => {
                    if (isSyncing === false) { // isSyncing initially set to null. Wait until false
                         this.loadData();
                    }
               });
     }

     private subscribeToTicketUpdates() {
          this.ticketStatusUpdateSubscription = this.ticketStatusTransitionService.updates$
               .subscribe(updates => {
                    if (updates != null) {
                         //this.loadData();
                         // LOC-1122
                         let index = this.appointments.findIndex(a => a.id == updates.id);
                         if (index >= 0) {
                              if (!updates.ticketStatusIsEndStatus &&
                                   (this.dateHelperService.isSameDay(this.dateHelperService.interperetDateTimeAsLocal(updates.apptStart), this.myDate)
                                        || this.dateHelperService.isSameDay(this.dateHelperService.interperetDateTimeAsLocal(updates.apptEnd), this.myDate))) {
                                   this.appointments[index] = updates;
                              }
                              else {
                                   this.appointments.splice(index, 1);
                              }
                              this.getTransitions();
                         }
                    }
               });
     }

     private async loadData() {
          this.isLoading = true;
          await this.getAppointments();
          await this.getTransitions();
          this.isLoading = false;
     }

     private async getAppointments() {
          try {
               let appointments = await this.storageService.appointments.getAll() as Appointment[];

               appointments = appointments
                    .filter(appt => !appt.ticketStatusIsEndStatus &&
                         (this.dateHelperService.isSameDay(this.dateHelperService.interperetDateTimeAsLocal(appt.apptStart), this.myDate)
                              || this.dateHelperService.isSameDay(this.dateHelperService.interperetDateTimeAsLocal(appt.apptEnd), this.myDate)))
                    .sort((b, a) => new Date(b.apptStart).getTime() - new Date(a.apptStart).getTime());

               this.appointments = appointments;
          } catch (error) {
               this.logger.logException(error);
               this.appointments = [];
          }
     }

     private async getTransitions() {
          try {
               this.transitions = await Promise.all(
                    this.appointments
                         .map(async appt => await this.ticketStatusTransitionService.getStatusTransition(appt.ticketStatusId))
               );
          } catch (error) {
               this.logger.logException(error);
               this.transitions = [];
          }
     }

     // LOC-1086
     myDate: string = this.zeroTime(this.getTodaysDate().toISOString());
     addDays(date: Date, days: number): Date {
          date.setDate(date.getDate() + days);
          return date;
     }
     onDateChange() {
          this.syncService.pushDateString(this.myDate);
          this.syncService.sync();
          this.getAppointments();
     }
     zeroTime(dateString: string): string {
          let date = new Date(dateString);
          date.setHours(0, 0, 0, 0);
          return date.toISOString();
     }

}
